import {ConversationHeader} from "@chatscope/chat-ui-kit-react";
import {A11YToolbox} from "./A11YToolbox";

export const AgentConversationHeader = ((props: { as: string}) => <ConversationHeader>
    <ConversationHeader.Content userName="Jan Kowalski" />
    <ConversationHeader.Actions>
        <A11YToolbox />
    </ConversationHeader.Actions>
</ConversationHeader>
);